module.exports = __webpack_public_path__ + "static/media/life-park-list-banner-desktop.7bf0e1a7.jpg";